import { BreakpointEnum } from '@fleet-beat/core';

export type Breakpoint = BreakpointEnum.XL | BreakpointEnum.MD | BreakpointEnum.SM | BreakpointEnum.XS;
